// extracted by mini-css-extract-plugin
export default {"sidebar":"Navbar_sidebar__8Quuu","anchor":"Navbar_anchor__IsU4g","nav":"Navbar_nav__MF9pa"};